import { render, staticRenderFns } from "./ScriptBuilderPage.vue?vue&type=template&id=520d9353&scoped=true&"
import script from "./ScriptBuilderPage.vue?vue&type=script&lang=ts&"
export * from "./ScriptBuilderPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520d9353",
  null
  
)

export default component.exports